
import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region NOTES

function _Notes(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Notes);
    if (!props.builder) {
        if (!hasValue) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, 'Notes')) {
            return null;
        }
    }
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={props.content} />;
}
const Notes = withLabelTokenParsing(_Notes, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Notes:
            if (!Utilities.isNullOrWhitespace(data.Notes)) {
                replaceString = Token.cleanTokenValueForReplacement(data.Notes);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Notes', token: Token.Notes }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: (display) => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: display || 'Notes:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Notes}}`, token: Token.Notes })),
        visibility: (display) => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: display || 'Notes',
                        name: 'Notes',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
};

// #endregion NOTES

export {
    Notes as Component,
    Tokens,
    TypeConfig
}